import { createStore } from 'vuex'
import { ViewCollection, ViewState } from '@/models/view'
import ViewsModule from './views'
import AppModule, { AppState } from './modules/app'
import NotificationsModule, { NotificationsState } from './modules/notifications'
import UserModule, { UserState } from './modules/user'
import ServicesModule, { ServicesState } from './modules/services'
import ContentModules, { ContentModuleNames } from './modules/content'
import TasksModule from './modules/tasks'

import {
  EntryState,
  CtProduct,
  CtOrder
} from '@/models/interfaces/content-type'


const ignoredMutations = ['Test']
const logger = store => {
  store.subscribe(mutation => {
    if (!ignoredMutations.includes(mutation.type)) {
      // console.log(`[Store] Mutation ${mutation.type}`, mutation)
      // console.log('[Store] Store', store)
    }
  })
}

export interface StateInterface {
  views?: ViewState<ViewCollection>;
  services?: ServicesState;
  app?: AppState;
  user?: UserState;
  orders?: EntryState<CtOrder>;
  products?: EntryState<CtProduct>;
}

export const store = createStore<StateInterface>({
  modules: {
    Services: ServicesModule,
    View: ViewsModule,
    App: AppModule,
    User: UserModule,
    Notifications: NotificationsModule,
    Tasks: TasksModule,
    ...ContentModules
  },
  plugins: process.env.NODE_ENV !== 'production' ? [logger] : [],
  getters: {
    ContentModules: () => ContentModuleNames.map(name => ({
      type: ContentModules[name].getters.Type(),
      name
    }))
  },
  actions: {
    Reset ({ dispatch }) {
      // console.log('[AppStore] Resetting state')
      dispatch('View.Reset').catch(console.error)
    },
    Authenticated ({ dispatch }) {
      dispatch('User/Auth').catch(console.error)
    }
  }
})

export default store
